import React, { useEffect, useState, useContext } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { useCompanyFix } from '../../../utils/company'
import UserContext from '../../../context/UserContext'
import * as moment from "moment-timezone"
import { HealthServiceDataViewStatus } from './HealthStatusService'
import envConfig from '../../../utils/envConfig'
import { useFixData, useHAProxyFixRoutes } from '../../../utils/fix'
import { deepClone } from '../../../utils/clone'

const fixMapping = {
    'FIXDropCopy': 'FIX Drop Copy',
    'FIXMarketData': 'FIX Market Data',
    'FIXInboundDropCopy': 'FIX Inbound Drop Copy',
    'FIXOrderRouting': 'FIX Order Routing',
    'BinaryMarketData': 'FIX Binary Market Data'
}


const HealthStatusServiceFix = ({ data, env }) => {

    const companyLookup = useCompanyFix(env)
    const token = useContext(UserContext)
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']
    const fixDataLookup = useFixData()
    const haProxyFixLookup = useHAProxyFixRoutes()

    const tab_col = [
        {
            field: "id",
            headerName: "ID",
            minWidth: 150,
            suppressSizeToFit: true,
            checkboxSelection: true,
        },
        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "sessionSubType",
            headerName: "Session Sub Type",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "initiator",
            headerName: "Initiator",
            minWidth: 150,
        },
        {
            field: "blocked",
            headerName: "Blocked",
            cellStyle: function (params) {
                if (params.value !== 'NO') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            },
            minWidth: 150,
        },
        {
            field: "redirect",
            headerName: "Redirect",
            minWidth: 150,
        },
        {
            field: "sender_sub_id",
            headerName: "Sender Sub ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "target_sub_id",
            headerName: "Target Sub ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "client_comp_id",
            headerName: "Client Comp ID",
            minWidth: 200,

        },
        {
            field: "server_comp_id",
            headerName: "Server Comp ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "notificationEmail",
            headerName: "Notification Email",
            minWidth: 200,

        },
        {
            field: "session_connect_time",
            headerName: "Session Connect Time",
            minWidth: 200,

        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
    ]

    const [tab_data, settab_data] = useState([])
    const [nodeName, setnodeName] = useState('')

    useEffect(() => {
        if (fixDataLookup && companyLookup && Object.keys(companyLookup).length > 0) {

            settab_data(Object.keys(data).sort((a, b) => (a.status === 'UP') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data[rowId])
                const companyName = companyLookup[row.id] ? companyLookup[row.id].name : '-'
                setnodeName(row.host_name)
                const tabs = [
                    {
                        'type': 'json',
                        'subheader': 'Metrics',
                        'content': row.fix_session_metrics,
                    },
                    {
                        'type': 'session_history',
                        'subheader': 'History',
                        'content': {
                            'sessionId': row.id,
                            'sessionType': fixMapping[row.fix_type],
                            'env': env
                        },
                    },
                ]

                let sessionConnectTime = row.session_connect_time ? row.session_connect_time : '-'
                if (sessionConnectTime !== '-') {
                    sessionConnectTime = moment(moment(sessionConnectTime, "YYYYMMDD-HH:mm:ss").format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                    sessionConnectTime = moment(sessionConnectTime).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                }

                let fixBlockedByTT = haProxyFixLookup[row.id] ? haProxyFixLookup[row.id].blocked : ''

                rowData.push({
                    'uniqueId': row.id,
                    'id': row.id,
                    'companyName': companyName,
                    'initiator': fixDataLookup[row.id] ? fixDataLookup[row.id].initiator : '',
                    'blocked': fixBlockedByTT === true ? "YES" : "NO",
                    'redirect': haProxyFixLookup[row.id] ? haProxyFixLookup[row.id].derivedRoutingLabel : '',
                    'sender_sub_id': row.sender_sub_id,
                    'target_sub_id': row.target_sub_id,
                    'client_comp_id': row.client_comp_id,
                    'server_comp_id': row.server_comp_id,
                    'session_connect_time': sessionConnectTime,
                    'sessionSubType': row.session_sub_type,
                    'status': row.status,
                    'detailView': {
                        'head': {
                            'Host': row.host_name,
                            'ID': row.id,
                        },
                        'data': tabs
                    },
                    'notificationEmail': fixDataLookup[row.id] ? fixDataLookup[row.id].notificationEmail : '',

                })

                return rowData
            }, []))
        }
        return () => {
            settab_data([])
        }
    }, [data, companyLookup, env, token.timezone, liteMode, fixDataLookup, haProxyFixLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Sessions </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>
            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceFix"
                defaultSubTab="Metrics"
                tableHeight={700}
                selection="multiple"
                nodeName={nodeName}
            />

        </Box>
    )
}

export default HealthStatusServiceFix